import type {ReactNode} from 'react';
import {NavLink} from 'react-router-dom';

import {menuItemVariants} from '@/components/ui/menu-item';
import {cn} from '@/utils/ui';

export type MenuItemProps = {
  path: string;
  text: string;
  icon: ReactNode;
  isSmall?: boolean;
  // allowedGroups?: UserGroup[];
};

const MenuItem = ({path, text, icon, isSmall}: MenuItemProps) => {
  return (
    <NavLink
      className={({isActive}) =>
        cn(
          menuItemVariants({variant: 'primary', active: isActive}),
          'group cursor-pointer px-4',
          isSmall && 'justify-center'
        )
      }
      to={path}
    >
      {({isActive}) => (
        <>
          <span
            className={cn(
              'text-neutral transition-colors group-hover:text-primary-dark',
              isActive && 'text-primary-dark'
            )}
          >
            {icon}
          </span>
          <span className={cn({hidden: isSmall})}>{text}</span>
        </>
      )}
    </NavLink>
  );
};

export default MenuItem;
